// ─── Demo Portal API Layer ───
// Calls local demo server (port 3457) which queues triggers for AIDA
// Completely separate from Salla waitlist flow

const API = 'http://localhost:3457/api/demo';

export async function whitelistNumber(phone, name, industry, extraPhone, extraName) {
  // Just stores info for the trigger call — actual whitelist happens on trigger
  return { success: true, phone, name, industry };
}

export async function triggerAgentMessage(phone, scenario, industry, name, extraPhone, extraName) {
  const res = await fetch(`${API}/trigger`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ phone, name, scenario, industry, extraPhone, extraName }),
  });
  return res.json();
}

export async function blacklistNumber(phone, sessionId) {
  const res = await fetch(`${API}/end`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: sessionId, phone }),
  });
  return res.json();
}

export async function sendCampaignToNumber(phone) {
  // TODO: When connected to real AIDA, trigger Latifa campaign message
  await new Promise(r => setTimeout(r, 1500));
  return { success: true };
}
